import { useCallback } from 'react';
import { isEmpty, isNullish } from 'remeda';
import { useGroupRules, usePartnerSettings } from 'src/graphql';
import { useGlobalStore } from 'src/store';
import { filterItemsByAccess } from 'src/utils/navigation/filter-items-by-access';
import { type NavigationDestination } from 'src/utils/navigation/navigation.types';
import { useScreenDimensions } from 'src/utils/system';

export const useNavigationAccess = () => {
  const { loading, checkValidity, groupRules } = useGroupRules();
  const { isMobile } = useScreenDimensions();
  const isMultiTenancyMode = useGlobalStore.use.isMultiTenancyMode();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();
  const { data: partnerSettings } = usePartnerSettings({ partnerId: selectedPartnerId });

  const isWorkingWithPartner = !isMultiTenancyMode || !isNullish(selectedPartnerId);

  const filterByAccess = useCallback(
    <Item extends NavigationDestination>(items: Item[]): Item[] =>
      filterItemsByAccess({
        items,
        checkValidity,
        isWorkingWithPartner,
        isMobile,
        partnerSettings,
        selectedPartnerId,
      }),
    [checkValidity, isWorkingWithPartner, isMobile, partnerSettings, selectedPartnerId],
  );

  return {
    filterByAccess,
    isReady: !loading && !isEmpty(groupRules),
    loading,
  };
};
